import * as videoplayer from './video'

require('slick-carousel');

export function init_search_sliders() {
  $('.search-result-slider').each((_, slider) => {
    const $slider = $(slider);
    $slider.one('mouseover', () => {
      const $track = $slider.find('.search-result-slider-track');
      $track.find('figure[data-src]').each((_, figure) => {
        const $image = $('<img>', {
          src: $(figure).data('src'),
        });
        $(figure).html($image);
      });
      $track.slick({
        arrows: true,
        dots: false,
        swipe: true,
        infinite: true,
        slidesToShow: 1,
        prevArrow: $slider.find('.slick-prev'),
        nextArrow: $slider.find('.slick-next'),
      });
    });
  });
}

export function init_preview_slider() {
  const $slider = $('.search-preview-slider');
  const $track = $('.search-preview-slider-track');
  const slider = $('.search-preview-slider-track').slick({
    arrows: true,
    dots: false,
    swipe: true,
    infinite: true,
    slidesToShow: 1,
    prevArrow: $slider.find('.slick-prev'),
    nextArrow: $slider.find('.slick-next'),
  });
  slider.on('afterChange', (e, s, index) => {
    $('.search-preview-state-index').text(index + 1);
  });
  $track.data('unslick', true);
}

export async function initalize() {
  init_search_sliders();
  const $slider = $('.carousel-slider');
  const slider = $slider.slick({
    arrows: true,
    dots: true,
    swipe: false,
    infinite: true,
    slidesToShow: 1,
    fade: true,
    prevArrow: $('.slick-prev'),
    nextArrow: $('.slick-next'),
    appendDots: $('.slick-dots-wrapper'),
  });
  const video = $('.slick-current .carousel-video');
  const player = await get_player(video, 0, slider);
  if (player) play(player);
  // Initalize all players in advance.
  setTimeout(() => {
    const slides = $('.slick-slide');
    for (let i = 0; i < slides.length; ++i) {
      get_player(slides.eq(i).find('.carousel-video'), i, slider);
    }
  }, 5000);

  let change_timeout = null;
  slider.on('beforeChange', async (e, sl, curr, next) => {
    if (change_timeout) {
      clearTimeout(change_timeout);
      change_timeout = null;
    }
    const video = $('.slick-current .carousel-video');
    const player = await get_player(video, curr, slider);
    if (player) player.pause();
  });

  slider.on('afterChange', async (e, sl, curr) => {
    const video = $('.slick-current .carousel-video');
    const player = await get_player(video, curr, slider);
    if (player) {
      play(player);
    } else {
      change_timeout = setTimeout(() => {
        change_timeout = null;
        slider.slick('slickNext');
      }, 15 * 1000);
    }
  });
}

async function initalize_video(video, slider) {
  const config = {
    controls: ['play-large'],
    disableContextMenu: false,
    ratio: '6:3',
    autopause: false,
  };
  const player = await videoplayer.player(video[0], config);
  player.muted = true;
  // Can't get Vimeo to play the same video again otherwise.
  player.loop = true;
  player.on('volumechange', () => {
    player.muted = true;
  });
  let previous_time = null;
  player.on('timeupdate', () => {
    const started = player.currentTime < 1;
    const ended = previous_time !== null && player.duration - previous_time < 1;
    if (started && ended) {
      slider.slick('slickNext');
    }
    previous_time = player.currentTime;
  });
  player.on('play', () => {
    previous_time = null;
  });
  return player;
}

const slides_plyrs = {};
async function get_player(video, slideid, slider) {
  let player = slides_plyrs[slideid];
  if (!player && (!video || !video.length)) {
    return null;
  }
  if (!player) {
    player = await initalize_video(video, slider);
    slides_plyrs[slideid] = player;
    if (!player.playing && slideid > 0) {
      player.play().then(() => {
        player.pause();
      });
    }
  }
  return player;
}

function play(player) {
  $(window).trigger('resize');
  player.currentTime = 0;
  player.play();
}
